import { sortBy } from "lodash";

import { ISpamStoreState } from "./reducer";

export interface IWithSpamState {
  entities: {
    spam: ISpamStoreState;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectTrustedEntries = (state: IWithSpamState) =>
  sortBy(Object.values(state.entities.spam.trusted || {}), entry => [entry.value.includes("@") ? 1 : 0, entry.value]);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectBlockedEntries = (state: IWithSpamState) =>
  sortBy(Object.values(state.entities.spam.blocked || {}), entry => [entry.value.includes("@") ? 1 : 0, entry.value]);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectBlockedEntriesLoading = (state: IWithSpamState) => state.entities.spam.blocked === undefined;
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectTrustedEntriesLoading = (state: IWithSpamState) => state.entities.spam.trusted === undefined;
